import React from "react";
import { SelectInput, SimpleForm, Button, ArrayField, Toolbar, SaveButton, Edit, Create, Datagrid, TextField, TextInput, 
	BooleanField, FormDataConsumer, ReferenceArrayInput, AutocompleteArrayInput, 
	required } from 'react-admin';
import EditIcon from '@material-ui/icons/Edit';
const {AUDIT_STATUS} = require('./components/audit_status');

const BatchCreateToolbar = props => (
	<Toolbar {...props} >
		<SaveButton label=" Save Domains " redirect="edit" submitOnEnter={false} />
	</Toolbar>
);
const typeChoices = [
	{id: 'site', name: 'Site'},
	{id: 'app', name: 'App'}
];
const validateDomainForm = fd => {
  const errors = {};
  if (fd.audit_status!=='unaudited' && !fd.bidder_id) {
    errors.bidder_id = {message: 'Bidder is required when Audit Reason is set.'};
  }
  return errors;
}
export const DomainBatchCreate = (props) => (
	<Create title="Create/Update Domains" {...props}>
		<SimpleForm toolbar={<BatchCreateToolbar />} validate={validateDomainForm} validateOnBlur={true}>
		  <SelectInput label="Type" source="type" choices={typeChoices} validate={required()} />
			<SelectInput label="Approval Status" source="audit_status" choices={AUDIT_STATUS} defaultValue="unaudited"/>
			<FormDataConsumer>
			{({ formData }) => (formData && formData.audit_status!=='unaudited') &&
				<ReferenceArrayInput source="bidder_id" label="Select Bidders" 
					reference="bidders"
					basePath='bidders'
					sort={{ field: 'name', order: 'ASC' }}
					filter={{domain_approval_required: true}}
					filterToQuery={searchText => ({ search_name: searchText })}
					validate={required()}
					>
					<AutocompleteArrayInput optionValue="code" 
					optionText={record => (record && record.name)?`${record.name} (${record.code})`:""} style={{ width: '50%' }}/>
				</ReferenceArrayInput>
			}
			</FormDataConsumer>
			<div style={{ width: '100%' }}>
				<h3>Batch Format For Domains:</h3>
				domai_name_or_app_bundle,audit_message<br/>
    		domai_name_or_app_bundle,audit_message<br/>
				domai_name_or_app_bundle,audit_message
			</div>
			<TextInput multiline source="content" label="Domains Batch" initialValue="" fullWidth/>
		</SimpleForm>
	</Create>
);

const EmptyToolbar = props => (
	<Toolbar {...props} >
		<Button href="/#/batchd/" label="Back to Batch processing" variant="contained" color="primary" startIcon={<EditIcon />} />
	</Toolbar>
);
export const DomainBatchEdit = (props) => (
	<Edit title="Batch Results" {...props} >
		<SimpleForm toolbar={<EmptyToolbar />} >
			<BooleanField source="success" label="Success?" />
			<ArrayField source="messages" label="Messages" style={{ width: '100%' }} >
				<Datagrid>
					<TextField source="message" />
				</Datagrid>
			</ArrayField>
		</SimpleForm>
	</Edit>
);
